import React from 'react';
import '../FullWidthRichText/styles.css';
import '../FullWidthRichText/subtitle.css';
import '../FullWidthRichText/typography.css';
import RenderingStyling from '../../../lib/RenderingStyling';
import BackgroundImageStyles from '../FullWidthRichText/backgroundImageStyles';
import { getTrackingAttributes } from '../SharedUtils/utils';
import {
  renderFeaturedHeading,
  renderPrimaryHeading,
  renderSecondaryHeading,
  renderText,
  renderCtaLink,
} from '../FullWidthRichText/fieldsRenderer';

import { addBackgroundColorVariables } from '../SharedUtils/themeColors';

import { useTheme, useInvertedButton, useInvertedColor } from '../SharedUtils/hooks';

const FullWidthRichText = ({ fields, rendering }) => {
  const componentId = `c-${rendering.uid}`;

  const { isLight } = useTheme();

  const widgetStyles = {};
  const widgetClasses = ['o-widget', 'c-full-width-rich-text', 'background-color-theme'];

  const isCtaInverted = useInvertedButton(fields);
  const isColorInverted = useInvertedColor(fields);

  addBackgroundColorVariables(fields, widgetStyles);

  if (fields.BackgroundImageCover?.value) widgetClasses.push('has-background-covered');
  if (isColorInverted) widgetClasses.push('is-inverted');
  if (fields.ImageHorizontalAlignment?.fields?.value?.value)
    widgetClasses.push(fields.ImageHorizontalAlignment.fields.value.value);
  if (fields.ImageVerticalAlignment?.fields?.value?.value)
    widgetClasses.push(fields.ImageVerticalAlignment.fields.value.value);
  if (fields.EnableMarginBottom?.value) widgetClasses.push('has-margin-bottom');
  if (fields.TextAlignCentered?.value) widgetClasses.push('u-text-center');

  const trackingAttributes = getTrackingAttributes(fields);

  return (
    <div
      id={componentId}
      className={widgetClasses.join(' ')}
      style={widgetStyles}
      {...RenderingStyling(rendering.componentName)}
    >
      <div className="c-container">
        <div className="full-width-wrapper">
          {renderFeaturedHeading({
            field: fields.FeatureHeading,
            classes: 'c-full-width-rich-text__feature-heading',
          })}
          {renderPrimaryHeading({
            fields: fields,
            classes: 'c-full-width-rich-text__primary-heading-for-columns',
          })}
          {renderSecondaryHeading({
            field: fields.SecondaryHeading,
            classes: 'c-full-width-rich-text__secondary-heading-for-columns',
          })}
          {renderText({ field: fields.Text, classes: 'c-full-width-rich-text__text' })}
          {renderCtaLink({
            field: fields.CallToAction,
            isInverted: isCtaInverted,
            tracking: trackingAttributes,
          })}
        </div>
      </div>

      <BackgroundImageStyles componentId={componentId} fields={fields} isLight={isLight} />
    </div>
  );
};

export default FullWidthRichText;
